import * as actions from './actions';

const initialState = {
    courses: [],
    yearGroups: [],
    countries: [],
    isLoadingCountryYearGroups: false,
    isProductCoursesLoaded: false,
    deselectCourse: false,
    productCourses: []
};

export default function (state = initialState, action) {
    switch (action.type) {
    case actions.GET_YEAR_GROUP_SUCCESS: {
        return { ...state, yearGroups: action.data };
    }
    case actions.GET_COUNTRY_SUCCESS: {
        return { ...state, countries: action.data };
    }

    case actions.GET_COUNTRY_YEAR_GROUPS_REQUEST: {
        return { ...state, isLoadingCountryYearGroups: true };
    }
    case actions.GET_COUNTRY_YEAR_GROUPS_SUCCESS: {
        return { ...state,
            isLoadingCountryYearGroups: action.isLoadingCountryYearGroups,
            yearGroups: action.yearGroups };
    }
    case actions.GET_COUNTRY_YEAR_GROUPS_FAILURE: {
        return { ...state, isLoadingCountryYearGroups: action.isLoadingCountryYearGroups };
    }

    case actions.GET_PRODUCT_COURSE_REQUEST:
    case actions.GET_SCHOOL_COURSE_REQUEST: {
        return { ...state,
            isProductCoursesLoaded: false,
            productCourses: []
        };
    }

    case actions.GET_PRODUCT_COURSE_SUCCESS:
    case actions.GET_SCHOOL_COURSE_SUCCESS: {
        return { ...state,
            isProductCoursesLoaded: true,
            productCourses: action.data
        };
    }
    case actions.GET_PRODUCT_COURSE_FAILURE:
    case actions.GET_SCHOOL_COURSE_FAILURE: {
        return { ...state,
            isProductCoursesLoaded: true,
            productCourses: []
        };
    }
    case actions.CLEAR_COURSE_LIST: {
        return { ...state, productCourses: action.productCourses };
    }

    case actions.DESELECT_COURSE: {
        return { ...state, deselectCourse: action.deselectCourse };
    }

    default:
        return { ...state };
    }
}



// WEBPACK FOOTER //
// ./app/containers/assign-courses/reducer.js